import { TypedAnalyticsEvent } from "@services/tracking/types/analyticsEvent";
import { ButtonClickTrackingInfo } from "@services/tracking/types/trackingInfo/buttonClickTrackingInfo";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsButtonImpression,
    getGoogleAnalyticsButtonImpression,
} from "./GoogleAnalyticsButtonImpression";

export interface GoogleAnalyticsLinkClick
    extends GoogleAnalyticsButtonImpression {}

const getGoogleAnalyticsLinkClick = (
    data: TypedAnalyticsEvent<ButtonClickTrackingInfo>,
): GoogleAnalyticsLinkClick => {
    return getGoogleAnalyticsButtonImpression(
        data,
        GoogleAnalyticsEvents.LinkClick,
    );
};

export { getGoogleAnalyticsLinkClick };
